import * as R from 'ramda';
function getCustomTooltipThemeStyles(theme) {
  return require("./".concat(theme, ".css"));
}
export var getThemeStyles = R.memoizeWith(R.identity, getCustomTooltipThemeStyles);